import { Provider, Signal } from "@angular/core";
import { ATOM_SIDE_PANEL_CLOSE_ARIA_LABEL } from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

/**
 * Localizes the default close (X) icon-button of `atom-side-panel-header`.
 *
 * Same approach as {@link provideAtomDialogLabels}: a `Signal<string>` that
 * follows live language switches.
 */
export const provideAtomSidePanelLabels = (): Provider[] => [
    {
        provide: ATOM_SIDE_PANEL_CLOSE_ARIA_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal("atom_side_panel.close_aria_label"),
    },
];
